import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-agent-search-delete-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSearchDeleteIconProps extends SvgIconProps {}

export function CcfAgentSearchDeleteIcon(props: CcfAgentSearchDeleteIconProps) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 20 20"
        sx={{fontSize: '24px'}}
        {...props}
      >
        <g id="ic_delete" clip-path="url(#clip-ic_delete)">
          <g id="delete" transform="translate(3.09 3.269)">
            <path
              id="Path_25264"
              data-name="Path 25264"
              d="M13.13,2.764H11.057V0H2.764V2.764H.691a.691.691,0,0,0,0,1.382H1.52l.9,8.5a1.1,1.1,0,0,0,1.037,1.175h6.911A1.1,1.1,0,0,0,11.4,12.647l.829-8.5h.9a.743.743,0,0,0,.691-.691.693.693,0,0,0-.691-.691ZM4.146,1.382H9.675V2.764H4.146Zm5.874,11.057H3.8L2.9,4.146H10.85Z"
            ></path>
            <path
              id="Path_25265"
              data-name="Path 25265"
              d="M11.2,12.8h1.382v4.838H11.2Z"
              transform="translate(-6.362 -7.271)"
            ></path>
            <path
              id="Path_25266"
              data-name="Path 25266"
              d="M17.6,12.8h1.382v4.838H17.6Z"
              transform="translate(-9.998 -7.271)"
            ></path>
          </g>
        </g>
    </SvgIcon>
  );
}

export default CcfAgentSearchDeleteIcon;
